module.exports = __webpack_public_path__ + "img/cards1_front28.72fea082.png";